import React from 'react';
const SelectableContext = /*#__PURE__*/ React.createContext(null);
export const makeEventKey = (eventKey, href = null)=>{
    if (eventKey !== null && eventKey !== undefined) return String(eventKey);
    return href || null;
};
export default SelectableContext;
